const allowedEDeliveryTypes = [
  "txt",
  "rtf",
  "pdf",
  "xps",
  "odt",
  "ods",
  "odp",
  "doc",
  "xls",
  "ppt",
  "docx",
  "xlsx",
  "pptx",
  "csv",
  "jpg",
  "jpeg",
  "tif",
  "tiff",
  "geotiff",
  "png",
  "svg",
  "wav",
  "mp3",
  "avi",
  "mpg",
  "mpeg",
  "mp4",
  "m4a",
  "mpeg4",
  "ogg",
  "ogv",
  "zip",
  "tar",
  "7z",
  "html",
  "htm",
  "xhtml",
  "css",
  "xml",
  "xsd",
  "gml",
  "rng",
  "xsl",
  "xslt",
  "dwg",
  "dwf",
  "dxf",
  "dgn",
  "jp2",
];

export const isAllowedEDeliveryAttachment = (extension: string) => {
  return allowedEDeliveryTypes.includes(extension.toLocaleLowerCase() ?? "no");
};
